import slugify from 'slugify';

const toSlug = (str: string) => slugify(str, { lower: true, trim: true, strict: true });

export { toSlug };
